import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Subscription, take } from 'rxjs';
import { UserSettings, APIResponse } from 'fakturnia-shared';
import { SettingsApiService } from 'shared/services/api/settings.api.service';
import { SettingsService } from 'shared/services/settings.service';
import { SnackbarService } from 'shared/services/snackbar.service';

@Component({
  standalone: true,
  selector: 'enable-gtu',
  imports: [CommonModule, MatCheckboxModule, MatSlideToggleModule, MatIconModule, MatTooltipModule],
  templateUrl: './enable-gtu.component.html',
  styleUrls: ['./enable-gtu.component.scss']
})
export class EnableGtuComponent implements OnInit, OnDestroy {

  private _subscriptions: Subscription[] = [];
  
  enableGTU = false;
  isProcessing = false;

  constructor(
    private _settingsApiService: SettingsApiService,
    private _settingsService: SettingsService,
    private _snackbarService: SnackbarService
  ) {}

  ngOnInit(): void {
    this._subscriptions.push(
      this._settingsService.getUserSettings().subscribe({
        next: (userSettings: UserSettings) => {
          this.enableGTU = userSettings.settings.autocomplete.enableGTU || false;
        }
      })
    );
  }

  ngOnDestroy(): void {
    this._subscriptions.forEach(sub => sub.unsubscribe());
  }

  toggleEnableGTU(): void {
    if (this.isProcessing) return;
    
    this.isProcessing = true;
    this.enableGTU = !this.enableGTU;
    
    this._settingsApiService.updateEnableGTU(this.enableGTU)
      .pipe(take(1))
      .subscribe({
        next: (response: APIResponse) => {
          if (response.success) {
            this._settingsService.refreshSettings();
            this._snackbarService.showSnackBar('Zapisano zmiany', 'success', 4000);
          } else {
            this._snackbarService.showSnackBar('Nie udało się zapisać zmian', 'error', 4000);
            // Revert change on error
            this.enableGTU = !this.enableGTU;
          }
          this.isProcessing = false;
        },
        error: () => {
          this._snackbarService.showSnackBar('Wystąpił błąd podczas zapisywania', 'error', 4000);
          // Revert change on error
          this.enableGTU = !this.enableGTU;
          this.isProcessing = false;
        }
      });
  }
}
